import React, { useEffect, useRef, useState } from "react";
import videoFile from "../Images/a villa at Masaar in 90 Seconds (3) (1).mp4";

export default function VideoFullViewportSection({
  src = videoFile,
  poster,
  className = "",
  style,
}) {
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [inViewOnce, setInViewOnce] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    let prevTimeout = null;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!inViewOnce && videoRef.current && src) {
              videoRef.current.src = src;
              setInViewOnce(true);
            }

            el.classList.remove("reveal");
            // el.offsetHeight;
            clearTimeout(prevTimeout);
            prevTimeout = setTimeout(() => {
              el.classList.add("reveal");
              if (videoRef.current) {
                const v = videoRef.current;
                v.play().catch(() => {});
              }
            }, 10);
          }
        });
      },
      { root: null, threshold: 0.35 }
    );

    io.observe(el);
    return () => {
      io.disconnect();
      clearTimeout(prevTimeout);
    };
  }, [src, inViewOnce]);

  const handleCanPlay = () => setIsLoaded(true);

  return (
    <section
      ref={containerRef}
      className={`video-viewport-section ${className}`}
      style={style}
    >
      <div className={`loading-overlay ${isLoaded ? "hidden" : ""}`}>
        <div className="spinner" aria-hidden />
      </div>

      <video
        ref={videoRef}
        src={videoFile}
        poster={poster}
        preload="none"
        muted
        loop
        playsInline
        controls={false}
        controlsList="nodownload noplaybackrate nofullscreen noremoteplayback"
        disablePictureInPicture
        onCanPlay={handleCanPlay}
        className="video-el"
      />

      <style>{`
        .video-viewport-section {
          position: relative;
          width: 100vw;
          height: 100vh;
          overflow: hidden;
          margin-top: 30px;
          padding: 0;
          background: #000;
          display: grid;
          place-items: center;
          opacity: 0;
          transform: translateY(24px) scale(0.98);
        //   border-radius: 25px;
        }

        .video-viewport-section.reveal {
          animation: revealFade 650ms ease-out forwards;
        }

        @keyframes revealFade {
          from { opacity: 0; transform: translateY(24px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        .video-viewport-section .video-el {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .loading-overlay {
          position: absolute;
          inset: 0;
          display: grid;
          place-items: center;
          background: linear-gradient(180deg, rgba(0,0,0,0.65), rgba(0,0,0,0.35));
          transition: opacity 300ms ease;
          pointer-events: none;
          border-radius: 25px;
        }
        .loading-overlay.hidden { opacity: 0; }

        .spinner {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          border: 4px solid rgba(255,255,255,0.35);
          border-top-color: #fff;
          animation: spin 0.9s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </section>
  );
}
